import React from 'react';

import { Link } from '~/lib/react-router-dom';

import { Alert, Breadcrumbs, Link as MuiLink, Typography } from '@mui/material';

import { pluralizeToString } from '~/utils/stringUtils';

import { accountPath } from './accountRelatedModel';
import { useAccountOfferId } from './useAccountOfferId';

interface Props {
  accountId: string;
  count?: number;
  isTruncated?: boolean;
  sortedBy: string;
  title: string;
}

export default function AccountListPageHeader({ accountId, count, isTruncated, sortedBy, title }: Props) {
  const offerId = useAccountOfferId();

  return (
    <>
      <Breadcrumbs sx={{ mb: 2 }}>
        <MuiLink component={Link} to={accountPath(accountId, offerId)} underline="hover">
          Related
        </MuiLink>
        <Typography color="text.primary">{title}</Typography>
      </Breadcrumbs>
      <Typography variant="h4" sx={{ mb: 1 }}>
        {title}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        {count === undefined ? `Sorted by ${sortedBy}` : `${pluralizeToString('item', count)} · Sorted by ${sortedBy}`}
      </Typography>
      {isTruncated && (
        <Alert severity="info" sx={{ mb: 3 }}>
          Showing the first {count} only.
        </Alert>
      )}
    </>
  );
}
